import FormMaster from '../FormMaster'
import { useTranslation } from 'react-i18next'

const Carrier = () => {
  const { t } = useTranslation(['fuel-type', 'common'])
  return <FormMaster
    title={t('fuel_type_information')}
    tableConfig={{
      key: "id",
      apiPath: "fuel/list",
      allowDelete: {
        visible: true,
        key: "fuel_id",
        apiPath: "fuel/delete",
        paramType: "param"
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'fuel_code',
          caption: t('fuel_code'),
          allowFiltering: true
        },
        {
          dataField: 'fuel_name',
          caption: t('fuel_name'),
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: t('edit_by'),
        }
      ],
      exportExcel: {
        fileName: t('fuel_type_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('fuel_code'), value: 'fuel_code' },
          { label: t('fuel_name'), value: 'fuel_name' },
          { label: t('edit_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      fuel_code: "",
      fuel_name: ""
    }}
    modalConfig={{
      visible: true,
      title: t('fuel_type_information'),
      required: ["fuel_code", "fuel_name"],
      fieldTypeNumber: [],
      paramName: "fuel_id",
      apiPath: {
        "get": '',
        "post": 'fuel/add',
        "put": 'fuel/update'
      },
      elements: [
        {
          fieldName: "fuel_code",
          label: t('fuel_code'),
          placeholder: t('fuel_code'),
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "fuel_name",
          label: t('fuel_name'),
          placeholder: t('fuel_name'),
          required: true,
          inputType: "text",
          isOneRow: true
        }
      ]
    }}
  />
}

export default Carrier